import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import * as color from '../../../constants/colors';

import isLoggedIn, {isAdmin, logout, isSA, isGM, isSY} from '../../../utils/auth';

import * as authActionCreators from '../../../actions/auth';
let allActionCreators = Object.assign({}, authActionCreators);



class HeaderRightMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
    };
   this.checkClick = this.checkClick.bind(this);
  }

  componentWillMount() {
    document.addEventListener('click', this.checkClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.checkClick, false);
  }

  checkClick(evt) {

    let winWidth = window.innerWidth;
    if(evt.clientX > (winWidth - 100) && evt.clientY < 100) {
      return;
    }

    if(this.state.menuOpen === true) {
      let targetElement = evt.target;

      do {
          if (targetElement == this.menuBody) {
              return;
          }
          targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside, should close
      this.setState({ menuOpen : false });
    }
    
  }

  userNav(page) {
    this.setState({menuOpen: false});
    history.push('/' + page);
  }

  toggleMenu() {
    this.setState({ menuOpen: !this.state.menuOpen });
  }

  nullRoute() {
    this.setState({menuOpen: false});
  }

  render() {
    return <div className='HeaderRightMenu'>
      <div className='iconWrapper' onClick={this.toggleMenu.bind(this)}></div>
      <div className={this.state.menuOpen ? 'menuWrapper open' : 'menuWrapper closed'} ref={(menuBody) => { this.menuBody = menuBody; }}>
        <div className={'menuItem firstItem lastItem'} onClick={() => {this.userNav('customer-profile')}}>Create New Card</div>
        {/*<div className={'menuItem lastItem'} onClick={() => {this.userNav('search-customers')}}>Search Existing Cards</div>*/}
        <div className='menuArrow' onClick={this.nullRoute.bind(this)}>
          <img src='/img/header/arrow_white.svg' />
        </div>
      </div>
    </div>
  }
}
export default HeaderRightMenu;

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

export const HeaderRightMenuContainer = connect(
  mapStateToProps,
  allActionCreators
)(HeaderRightMenu);